// extracted by mini-css-extract-plugin
module.exports = {"tableWrapper":"Table_tableWrapper__QhXw1","col":"Table_col__1W7VF","fulfillmentStatus":"Table_fulfillmentStatus__2Jje3","emailCol":"Table_emailCol__3UI63"};